export const validateLocation = (
  location,
  type,
  deliveryType,
  otherLocation
) => {
  const errors = {};

  const currentLocation = location; // Source or destination
  const isLocal = deliveryType === 'LOCAL';

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  // Check required fields for LOCAL delivery

  if (isLocal) {
    const isLocalityEmpty = !currentLocation?.locality?.trim();
    const isInvalidSelection =
      !currentLocation?.city?.trim() ||
      !currentLocation?.state?.trim() ||
      !currentLocation?.country?.trim();

    // First: required check
    if (isLocalityEmpty) {
      errors.locality = `${capitalizeFirstLetter(type)} Locality is required`;
    }

    // Second: check if selected from list (only if not already showing required error)
    if (!isLocalityEmpty && isInvalidSelection && !errors.locality) {
      errors.locality = `${capitalizeFirstLetter(
        type
      )} must be selected from the list. Manual entry is not allowed.`;
    }
  }

  // Delivery type specific validation (locality, state, country should not match between source and destination)
  if (otherLocation) {
    if (isLocal) {
      if (
        currentLocation?.locality?.trim() &&
        otherLocation?.locality?.trim() &&
        currentLocation.locality.trim().toLowerCase() ===
          otherLocation.locality.trim().toLowerCase()
      ) {
        errors.locality = `${
          type === 'source' ? 'Source' : 'Destination'
        } locality should not be the same as ${
          type === 'source' ? 'destination' : 'source'
        }`;
      }

      if (
        currentLocation?.locality?.trim() !== '' &&
        otherLocation?.locality?.trim() !== '' &&
        currentLocation.state.trim().toLowerCase() !==
          otherLocation.state.trim().toLowerCase()
      ) {
        errors.locality = `${
          type === 'source' ? 'Source' : 'Destination'
        } locality should be from the same state as ${
          type === 'source' ? 'destination' : 'source'
        } for local deliveries.`;
      }
    }
  }

  return errors;
};
